import React from 'react';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import styles from './EArchiveGroupsListActions.module.scss';
import { useSelectUsersContext } from '../../../Services/SelectUsersContext';
import { useGroupsContext } from '../../../Services/GroupsContext';
import { CreateGroupMode } from '../../../Enums/CreateGroupMode.enum';
import EArchiveGroupsListCreateModal from '../EArchiveGroupsListCreateModal/EArchiveGroupsListCreateModal';
import { GroupListContent } from '../../../Enums/GroupListContent.enum';
import EArchiveCreateGroupToolbar from '../../EArchiveGroupToolbar/EArchiveCreateGroupToolbar';

const EArchiveGroupsListActions = () => {
	const { startSelectingUsers, stopSelectingUsers } = useSelectUsersContext();
	const {
		createGroupMode,
		setCreateGroupMode,
		setGroupListContent,
		groupListContent,
	} = useGroupsContext();

	const handleAddAllClick = () => {
		setCreateGroupMode(CreateGroupMode.ALL_USERS);
		setGroupListContent(GroupListContent.GROUPS);
		stopSelectingUsers();
	};

	const handleSelectClick = () => {
		setCreateGroupMode(CreateGroupMode.SELECTED_USERS);
		setGroupListContent(GroupListContent.PATIENTS);
		startSelectingUsers();
	};

	const closeCreateGroupModal = () => {
		setCreateGroupMode(undefined);
		stopSelectingUsers();
	};

	const handleDeleteGroupsClick = () => {
		setGroupListContent(GroupListContent.GROUPS_DELETE);
	};

	const handleCancelDelete = () => {
		setGroupListContent(GroupListContent.GROUPS);
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.buttonsContainer}>
				<LinkButton
					title={'component.eArchive.groups.createGroupAddAll'}
					theme={Theme.BLUE}
					onClick={handleAddAllClick}
				/>
				<LinkButton
					title={'component.eArchive.groups.createGroupSelect'}
					theme={Theme.BLUE}
					onClick={handleSelectClick}
				/>
				<LinkButton
					title={'component.eArchive.groups.deleteGroup'}
					theme={Theme.BLUE}
					onClick={handleDeleteGroupsClick}
				/>
			</div>
			<div className={styles.buttonsContainer}>
				{groupListContent === GroupListContent.GROUPS_DELETE && (
					<LinkButton
						title={'base.shared.cancel'}
						theme={Theme.RED}
						onClick={handleCancelDelete}
						className={styles.right}
					/>
				)}
			</div>
			{createGroupMode === CreateGroupMode.ALL_USERS && (
				<EArchiveGroupsListCreateModal isOpen onClose={closeCreateGroupModal} />
			)}
			{createGroupMode === CreateGroupMode.SELECTED_USERS && (
				<EArchiveCreateGroupToolbar />
			)}
		</div>
	);
};

export default EArchiveGroupsListActions;
